<template>
    <div>
        <md-steppers :md-active-step.sync="active"
            md-linear>
            <!-- STEP 1: ADD ORGANIZATION -->
            <md-step id="first"
                :md-label="$tc('organizations.organization',1)"
                :md-done.sync="first"
                :md-editable="false">
                <organization-maintenance @neworganization="setOrganizationData"></organization-maintenance>
            </md-step>
            <!-- STEP 2: ADD USER -->
            <md-step id="second"
                :md-label="$tc('users.user',1)"
                :md-done.sync="second"
                :md-editable="false">
                <user-maintenance @newuser="setUserData"
                    @previous="setDone('second','first')"></user-maintenance>
            </md-step>
            <!-- STEP 3: CONFIRMATION -->
            <md-step id="third"
                :md-label="$t('validations.confirmation')"
                :md-done.sync="third"
                :md-editable="false">
                <div class="md-layout">
                    <md-card class="md-layout-item md-gutter md-small-size-100 md-xsmall-size-100">
                        <md-card-header>
                            <div class="md-title">
                                {{ $tc('organizations.organization',1) }}
                            </div>
                        </md-card-header>
                        <md-card-content>
                            <div class="md-layout">
                                <div class="md-layout-item">
                                    <md-table>
                                        <md-table-row>
                                            <md-table-cell :style="{ 'text-align':'left' }">
                                                <strong>{{ $t('organizations.name') }}:</strong>
                                            </md-table-cell>
                                            <md-table-cell>{{ this.organization.organization_name }}</md-table-cell>
                                        </md-table-row>
                                        <md-table-row>
                                            <md-table-cell :style="{ 'text-align':'left' }">
                                                <strong>{{ $t('organizations.nipc') }}:</strong>
                                            </md-table-cell>
                                            <md-table-cell>{{ this.organization.nipc }}</md-table-cell>
                                        </md-table-row>
                                        <md-table-row>
                                            <md-table-cell :style="{ 'text-align':'left' }">
                                                <strong>{{ $t('organizations.phone') }}:</strong>
                                            </md-table-cell>
                                            <md-table-cell>{{ this.organization.phone }}</md-table-cell>
                                        </md-table-row>
                                        <md-table-row>
                                            <md-table-cell :style="{ 'text-align':'left' }">
                                                <strong>{{ $t('organizations.email') }}:</strong>
                                            </md-table-cell>
                                            <md-table-cell>{{ this.organization.email }}</md-table-cell>
                                        </md-table-row>
                                        <md-table-row>
                                            <md-table-cell :style="{ 'text-align':'left' }">
                                                <strong>{{ $t('organizations.street') }}:</strong>
                                            </md-table-cell>
                                            <md-table-cell>{{ this.organization.street }}</md-table-cell>
                                        </md-table-row>
                                        <md-table-row>
                                            <md-table-cell :style="{ 'text-align':'left' }">
                                                <strong>{{ $t('organizations.city') }}:</strong>
                                            </md-table-cell>
                                            <md-table-cell>{{ this.organization.city }}</md-table-cell>
                                        </md-table-row>
                                        <md-table-row>
                                            <md-table-cell :style="{ 'text-align':'left' }">
                                                <strong>{{ $t('organizations.state') }}:</strong>
                                            </md-table-cell>
                                            <md-table-cell>{{ this.organization.state }}</md-table-cell>
                                        </md-table-row>
                                        <md-table-row>
                                            <md-table-cell :style="{ 'text-align':'left' }">
                                                <strong>{{ $t('organizations.zip-code') }}:</strong>
                                            </md-table-cell>
                                            <md-table-cell>{{ this.organization.zip_code }}</md-table-cell>
                                        </md-table-row>
                                        <md-table-row>
                                            <md-table-cell :style="{ 'text-align':'left' }">
                                                <strong>{{ $t('organizations.select-time') }}:</strong>
                                            </md-table-cell>
                                            <md-table-cell>{{ this.formatDeliveryHour(this.organization.preferred_delivery_hour) }}</md-table-cell>
                                        </md-table-row>
                                    </md-table>
                                </div>
                            </div>
                        </md-card-content>
                    </md-card>
                    <md-card class="md-layout-item md-gutter md-small-size-100 md-xsmall-size-100">
                        <md-card-header>
                            <div class="md-title">
                                {{ $tc('users.user',1) }}
                            </div>
                        </md-card-header>
                        <md-card-content>
                            <div class="md-layout">
                                <div class="md-layout-item">
                                    <md-table>
                                        <md-table-row>
                                            <md-table-cell :style="{ 'text-align':'left' }">
                                                <strong>{{ $t('users.first-name') }}:</strong>
                                            </md-table-cell>
                                            <md-table-cell>{{ this.user.first_name }}</md-table-cell>
                                        </md-table-row>
                                        <md-table-row>
                                            <md-table-cell :style="{ 'text-align':'left' }">
                                                <strong>{{ $t('users.last-name') }}:</strong>
                                            </md-table-cell>
                                            <md-table-cell>{{ this.user.last_name }}</md-table-cell>
                                        </md-table-row>
                                        <md-table-row>
                                            <md-table-cell :style="{ 'text-align':'left' }">
                                                <strong>{{ $t('users.phone') }}:</strong>
                                            </md-table-cell>
                                            <md-table-cell>{{ this.user.phone }}</md-table-cell>
                                        </md-table-row>
                                        <md-table-row>
                                            <md-table-cell :style="{ 'text-align':'left' }">
                                                <strong>{{ $t('users.email') }}:</strong>
                                            </md-table-cell>
                                            <md-table-cell>{{ this.user.email }}</md-table-cell>
                                        </md-table-row>
                                    </md-table>
                                </div>
                            </div>
                        </md-card-content>
                    </md-card>
                </div>
                <md-button class="md-raised md-primary"
                    @click="setDone('third', 'second')">
                    {{ $t('actions.previous') }}
                </md-button>
                <md-button class="md-raised"
                    @click="close">
                    {{ $t('actions.cancel') }}
                </md-button>
                <md-button class="md-raised md-primary"
                    @click="save()">
                    {{ $t('actions.confirm') }}
                </md-button>
            </md-step>
        </md-steppers>
    </div>
</template>

<script>
import organizationMaintenance from '@/components/organizations/Maintenance/index'
import userMaintenance from '@/components/users/Maintenance'
import organizationsService from '@/components/organizations/services/organizations'
import _ from 'lodash'
import { DateTime } from 'luxon'

export default {
    name: 'NewOrganization',

    components: {
        organizationMaintenance,
        userMaintenance
    },

    data () {
        return {
            active: 'first',
            first: false,
            second: false,
            third: false,

            organization: {},
            user: {}
        }
    },

    methods: {
        setDone (id, index) {
            this[id] = true

            if (index) {
                this.active = index
            }
        },

        close () {
            this.$router.go(-1)
        },

        formatDeliveryHour (deliveryDateTime) {
            let self = this
            if (deliveryDateTime !== undefined) {
                return DateTime.fromISO(self.organization.preferred_delivery_hour.toISOString()).toLocaleString(DateTime.TIME_24_SIMPLE)
            } else {
                return ''
            }
        },

        setOrganizationData (fetchedOrganization) {
            let self = this

            self.organization = _.cloneDeep(fetchedOrganization)
            self.setDone('first', 'second')
        },

        setUserData (fetchedUser) {
            let self = this

            self.user = _.cloneDeep(fetchedUser)
            self.setDone('second', 'third')
        },

        async save () {
            let self = this

            let params = {
                organizationName: self.organization.organization_name,
                nipc: self.organization.nipc,
                organizationPhone: self.organization.phone,
                organizationEmail: self.organization.email,
                street: self.organization.street,
                city: self.organization.city,
                state: self.organization.state,
                zip_code: self.organization.zip_code,
                preferred_delivery_hour: self.organization.preferred_delivery_hour,
                firstName: self.user.first_name,
                lastName: self.user.last_name,
                userPhone: self.user.phone,
                userEmail: self.user.email,
                password: self.user.password
            }

            let response = await organizationsService.createWithUser(params)

            if (response.data.organization_id) {
                self.$router.go(-1)
            } else {
                console.log('Error')
            }
        }
    },

    created () {
    }
}
</script>
